import React, { useEffect } from 'react';

import { ProductInstagramGridWrapper, StyledH5 } from './ProductInstagramGridStyles';

var _ref = React.createElement(
  StyledH5,
  null,
  'Styled on Insta'
);

var _ref2 = React.createElement(ProductInstagramGridWrapper, { id: 'ProductInstagramGridWrapper' });

var ProductInstagramGrid = function ProductInstagramGrid() {
  useEffect(function () {
    // Add 460grid script to this div
    var fourSixtyComponent = document.getElementById('ProductInstagramGridWrapper');
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//foursixty.com/media/scripts/fs.slider.v2.5.js';
    script.setAttribute('data-feed-id', 'dormify');
    script.setAttribute('data-open-links-in-same-page', 'false');
    script.setAttribute('data-theme', 'slider_v2_5');
    script.setAttribute('data-page-size', '6');
    script.setAttribute('data-connector-filter', '5771');
    script.setAttribute('data-for-url', 'true');
    script.setAttribute('data-cell-size', '20%');
    script.setAttribute('data-has-posts-selector', '#foursixty-hideable-container');
    fourSixtyComponent.appendChild(script);
  }, []);

  return React.createElement(
    'div',
    { style: { display: 'none' }, id: 'foursixty-hideable-container' },
    _ref,
    _ref2
  );
};

export default React.memo(ProductInstagramGrid);